module.exports = __webpack_public_path__ + "img/img.19fe0b6e.png";